import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Grid, FormControl, InputLabel, Select, MenuItem, TextField, FormControlLabel, Checkbox } from "@material-ui/core";
import { CompanyBookingFilter, fetchCompanyBookings } from "api/bookings";
import i18n from "./i18n";

type Filters = Parameters<typeof fetchCompanyBookings>[0];

interface CalendarFilterDialogProps {
    clubId: string | undefined,
    show: boolean,
    onReset: boolean,
    companyExclusiveBookingFilters: Filters,
    onSetCompanyExclusiveBookingFilters: (companyExclusiveBookingFilters: Filters) => void,
    onClose: () => void,
    onSetReset: (action: boolean) => void;
    onRefreshCompanyBooking: (clubId: string) => void,
}

// booking status
const bookingFilter: CompanyBookingFilter[] = ["all", "company-shared", "company-exclusive"];

// eslint-disable-next-line arrow-body-style
const CalendarFilterDialog = ({ clubId, show, onClose, onReset, onSetReset, companyExclusiveBookingFilters, onSetCompanyExclusiveBookingFilters, onRefreshCompanyBooking }: CalendarFilterDialogProps) => {
    // render
    return (
        <Dialog
            fullWidth
            open={show}
            onClose={onClose}
        >
            <DialogTitle>{i18n.filter}</DialogTitle>
            <DialogContent dividers>
                <Grid container spacing={2}>
                    {/* booking status */}
                    <Grid item xs={12}>
                        <FormControl fullWidth>
                            <InputLabel>{i18n.filter}</InputLabel>
                            <Select
                                label={i18n.filter}
                                value={companyExclusiveBookingFilters.filter || "all"}
                                onChange={(e) => onSetCompanyExclusiveBookingFilters({ ...companyExclusiveBookingFilters, filter: e.target.value as CompanyBookingFilter })}
                            >
                                {bookingFilter.map((t) => (
                                    <MenuItem key={t} value={t}>{i18n.bookingFilter[t]}</MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </Grid>

                    {/* booking query */}
                    <Grid item xs={12}>
                        <TextField
                            fullWidth
                            label={i18n.bookingQuery}
                            value={companyExclusiveBookingFilters.query || undefined}
                            onChange={(e) => onSetCompanyExclusiveBookingFilters({ ...companyExclusiveBookingFilters, query: e.target.value })}
                        />
                    </Grid>
                    {/* booking Virtual Event */}
                    <Grid item xs={12}>
                        <FormControl>
                            <FormControlLabel
                                control={(
                                    <Checkbox
                                        checked={companyExclusiveBookingFilters.isVirtualEvent}
                                        color="primary"
                                        onChange={(e) => onSetCompanyExclusiveBookingFilters({ ...companyExclusiveBookingFilters, isVirtualEvent: (e.target.checked === false ? undefined : e.target.checked) })}
                                    />
                                )}
                                label={i18n.isVirtualEvent}
                            />
                        </FormControl>
                    </Grid>

                </Grid>
            </DialogContent>
            <DialogActions>
                <Button color="secondary" onClick={() => { onSetCompanyExclusiveBookingFilters({ ...companyExclusiveBookingFilters, isVirtualEvent: undefined, query: undefined, filter: "all" }); onSetReset(!onReset); onClose(); }} style={{ marginRight: "auto" }}>
                    {i18n.reset}
                </Button>
                <Button color="secondary" onClick={onClose}>
                    {i18n.cancel}
                </Button>
                <Button color="primary" onClick={() => { onRefreshCompanyBooking(clubId!); onClose(); }}>
                    {i18n.apply}
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default CalendarFilterDialog;
